import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { COLUMN } from '../constants';

export const isColumn = isElementType(COLUMN);
